import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CategoryPage from "../pages/projects/category";
import ProjectDetailPage from "../pages/projects/detail";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/projects/:category",
    element: <CategoryPage />,
  },
  {
    path: "/projects/:category/:projectId",
    element: <ProjectDetailPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;